<template>
  <div class="textcenter">
    <dl>
      <dd>
        建築予定地（または建築希望地）をご入力いただきますと、より正確な価格をご覧いただけます。
      </dd>
      <!-- <br />
      <dd>
        <a
          href="https://www.google.com"
          target="_blank"
          style="text-decoration: underline;"
        >
          なぜ建築予定地によって価格が変わるのか？
        </a>
      </dd> -->
    </dl>
    <div class="btns">
      <div class="btn__common">
        <input
          type="button"
          name="Submit"
          value="建築地入力"
          class=""
          @click="constrInput"
        />
      </div>
      <div class="btn__common typeBlack">
        <input
          type="button"
          name="Submit"
          value="決まっていない"
          class=""
          @click="constrSkip"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  data() {
    return {};
  },
  props: {
    planId: undefined,
    specDiv: undefined,
    entranceDirectionCd: undefined
  },
  methods: {
    constrInput: function() {
      this.closeModal();
      this.$router.push({
        name: "ConstructInput",
        params: {
          planId: this.planId,
          specDiv: this.specDiv,
          entranceDirectionCd: this.entranceDirectionCd
        }
      });
    },
    constrSkip: function() {
      axios
        .post("/api/plan/constr/skip/init")
        .then(res => {
          if (res.data.result == 1) {
            this.$router.push({ name: "Error" });
          } else if (res.data.result == 0) {
            this.closeModal();
            this.$router.push({
              name: "PlanDetail",
              query: {
                planId: this.planId,
                specDiv: this.specDiv,
                entranceDirectionCd: this.entranceDirectionCd
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$router.push({ name: "Error" });
        });
    },
    closeModal: function() {
      $.magnificPopup.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.contentpopup .popin .textcenter {
  text-align: center;
}
</style>
